import React, { useState, useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Scanner from "../components/Scanner";
import CamScanner from "../components/CamScanner";
import Loading from "../components/Loading";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import "./Inventory.css";
import { apiFetch } from "../components/api"
import AutocompleteSelect from "../components/FilterSelect";

function Inventory() {
  const [items, setItems] = useState([]);
  const [filteredItems, setFilteredItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [locationList, setLocationList] = useState([]);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  const [locModal, setLocModal] = useState({ open: false, item: null, locationId: "", stock: "", stateId: "", transferQty: "", mode: "location", });
  const [logModal, setLogModal] = useState({ open: false, productId: null, productName: "", logs: [], loading: false, error: null, });
  const [specModal, setSpecModal] = useState({ open: false, title: "", spec: null });
  const [stateOptions, setStateOptions] = useState([]);
  const [locChangeText, setLocChangeText] = useState("");
  const [splitLocText, setSplitLocText] = useState("");

  const searchInputRef = useRef(null);
  const scannerRef = useRef(null);
  const descRef = useRef(null); 

  const [descItem, setDescItem] = useState(null);
  const [descPos, setDescPos] = useState({ x: 0, y: 0 });

  const [showScanner, setShowScanner] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [scannerTarget, setScannerTarget] = useState(null);


  // 즐겨찾기 상태
  const username = localStorage.getItem("username");
  const favoritesKey = username ? `favorites_${username}` : null;
  const [favorites, setFavorites] = useState([]);
  const [showFavoritesOnly, setShowFavoritesOnly] = useState(false);

  const [labelBusy, setLabelBusy] = useState(false);

  //스마트 패트롤
  const [patrolMode, setPatrolMode] = useState(false);
  const [patrolLocation, setPatrolLocation] = useState(null);
  const [patrolItems, setPatrolItems] = useState([]);
  const [patrolScannedMap, setPatrolScannedMap] = useState({});
  const [lastLocationCode, setLastLocationCode] = useState("");
  // const { setNavigationBlocker, setBeforeNavigate } = useOutletContext();

  const location = useLocation();
  const navigate = useNavigate();
  // const prevPathRef = useRef(location.pathname);
  const skipBeforeUnloadRef = useRef(false);

  const normalize = (s) => String(s || "").replace(/[\t\r\n]+/g, "").trim();

  const toSpecObj = (v) => {
    if (!v) return null;
    if (typeof v === "object") return v;
    if (typeof v === "string") {
      const s = v.trim();
      if (!s) return null;
      if (s.startsWith("{") || s.startsWith("[")) {
        try {
          return JSON.parse(s);
        } catch (e) {
          return { value: s };
        }
      }
      return { value: s };
    }
    return { value: String(v) };
  };

  const flattenSpecRows = (obj) => {
    const out = [];
    const root = toSpecObj(obj);
    if (!root) return out;

    // payload 형태: { group, display, spec:{k:{raw,text}} }
    if (root && typeof root === "object" && root.spec && typeof root.spec === "object") {
      const s = root.spec;
      Object.keys(s).forEach((k) => {
        const it = s[k];
        if (it && typeof it === "object") {
          out.push({
            key: k,
            raw: it.raw !== undefined ? it.raw : "",
            text: it.text !== undefined ? it.text : "",
          });
        } else {
          out.push({ key: k, raw: it, text: String(it ?? "") });
        }
      });
      return out;
    }

    // 그냥 dict이면 1단 flatten
    Object.keys(root).forEach((k) => {
      const v = root[k];
      out.push({
        key: k,
        raw: v,
        text: typeof v === "string" ? v : JSON.stringify(v),
      });
    });
    return out;
  };

  const changeMetadata = (item, mode = "location") => {
    let stateId = "";

    if (mode === "state" && Array.isArray(stateOptions) && stateOptions.length > 0) {
      const found = stateOptions.find(
        (opt) =>
          (opt.id ?? opt.value) &&
          (opt.name?.toLowerCase?.() ?? opt.label?.toLowerCase?.() ?? "") ===
            String(item.state__name ?? "").toLowerCase()
      );
      stateId = found ? String(found.id ?? found.value) : "";
      setSplitLocText("");
    }
    if (mode === "location") {
      // const it = item || {};
      // const cur =
      //   it.location__name
      //     ? `${it.location__container__name || ""}-${it.location__name}`
      //     : (it.location__container__name || "위치 없음");
      // setLocChangeText(cur);
      setLocChangeText("");
    }
    setLocModal({ open: true, item, locationId: "", stock: String(item.stock ?? ""), stateId, transferQty: String(item.stock ?? ""), mode });
  };

  const aliveRef = useRef(true);

  useEffect(() => {
    aliveRef.current = true;
    return () => {
      aliveRef.current = false;
    };
  }, []);

  const focusScanner = () => {
    requestAnimationFrame(() => {
      if (!aliveRef.current) return;
      if (!searchInputRef.current) return;
      searchInputRef.current.focus();
    });
  };

  const openScanner = (target = "default") => {
    setScannerTarget(target);
    setShowScanner(true);
  };

  const handleDetected = (code) => {
    setShowScanner(false);

    const cleanCode = normalize(code);

    if (scannerTarget === "location" || scannerTarget === "splitLocation") {
      const scannedLocation = locationList.find(
        (loc) => normalize(loc.barcode) === cleanCode
      );

      if (!scannedLocation) {
        alert(`등록되지 않은 위치 바코드: ${cleanCode}`);
        setScannerTarget(null);
        return;
      }

      if (scannerTarget === "location") {
        setLocChangeText(scannedLocation.display_name || "");
        setLocModal((prev) => ({
          ...prev,
          locationId: String(scannedLocation.id),
        }));
      }

      if (scannerTarget === "splitLocation") {
        setSplitLocText(scannedLocation.display_name || "");
        setLocModal((prev) => ({
          ...prev,
          locationId: String(scannedLocation.id),
        }));
      }

      setScannerTarget(null);
      return;
    }

    setScannerTarget(null);
    handleScan(code);
  };

  //스마트패트롤 나가기 동작
  useEffect(() => {
    if (!patrolMode) return;

    let navigating = false;

    const onPopState = async () => {
      if (navigating) return;
      navigating = true;

      const ok = await exitSmartPatrol();
      if (!ok) {
        window.history.pushState(null, "", window.location.href);
      }

      navigating = false;
    };

    const onBeforeUnload = (e) => {
      if (skipBeforeUnloadRef.current) return;

      e.preventDefault();
      e.returnValue = "";
    };

    const onDocumentClick = async (e) => {
      if (navigating) return;
      if (e.defaultPrevented) return;
      if (e.button !== 0) return;
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;

      const anchor = e.target.closest("a[href]");
      if (!anchor) return;

      const href = anchor.getAttribute("href");
      if (!href) return;
      if (href.startsWith("http")) return;
      if (href.startsWith("#")) return;
      if (anchor.target === "_blank") return;

      const nextUrl = new URL(anchor.href, window.location.origin);
      const nextPath = `${nextUrl.pathname}${nextUrl.search}${nextUrl.hash}`;
      const currentPath = `${window.location.pathname}${window.location.search}${window.location.hash}`;

      if (nextPath === currentPath) return;

      e.preventDefault();
      e.stopPropagation();

      navigating = true;

      const ok = await exitSmartPatrol();
      if (ok) {
        navigate(nextPath);
      }

      navigating = false;
    };

    window.history.pushState(null, "", window.location.href);
    window.addEventListener("popstate", onPopState);
    window.addEventListener("beforeunload", onBeforeUnload);
    document.addEventListener("click", onDocumentClick, true);

    return () => {
      window.removeEventListener("popstate", onPopState);
      window.removeEventListener("beforeunload", onBeforeUnload);
      document.removeEventListener("click", onDocumentClick, true);
    };
  }, [patrolMode, patrolItems, items, patrolLocation, locationList, navigate]);

  useEffect(() => {
    const ua = navigator.userAgent || "";
    const uaMobile = /Android|iPhone|iPad|iPod/i.test(ua);

    const check = () => {
      const narrow = window.innerWidth <= 768;  // 폭 768px 이하를 모바일로 간주
      setIsMobile(uaMobile || narrow);
    };

    check(); // 처음 한 번
    window.addEventListener("resize", check);
    return () => window.removeEventListener("resize", check);
  }, []);

  // 즐겨찾기 로드
  useEffect(() => {
    if (favoritesKey) {
      const saved = localStorage.getItem(favoritesKey);
      if (saved) setFavorites(JSON.parse(saved));
    } else {
      setFavorites([]);
    }
  }, [favoritesKey]);
  
  // 브라우저 탭/창 복귀 시 포커스
  useEffect(() => {
    const handleFocus = () => {
      setTimeout(() => {
        if (!aliveRef.current) return;
        if (!searchInputRef.current) return;
        searchInputRef.current.focus();
      }, 100);
    };
    window.addEventListener("focus", handleFocus);
    const handleVisibilityChange = () => {
      if (!document.hidden) handleFocus();
    };
    document.addEventListener("visibilitychange", handleVisibilityChange);

    handleFocus();

    return () => {
      window.removeEventListener("focus", handleFocus);
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, []);

  useEffect(() => {
    let alive = true;

    (async () => {
      try {
        const [statesRes, barcodeRes, invRes] = await Promise.all([
          apiFetch("/api/inventory/states/"),
          apiFetch("/api/inventory/barcode/"),
          apiFetch("/api/inventory/"),
        ]);

        if (!alive) return;

        // states
        setStateOptions(Array.isArray(statesRes?.data) ? statesRes.data : []);

        // inventory
        const arr = Array.isArray(invRes?.data) ? invRes.data : [];
        setItems(arr);
        setFilteredItems(arr);

        if (username) {
          const myTempCount = arr.filter((x) => x.temp_inventory === username).length;
          if (myTempCount > 0) {
            alert(`임시보관하고 있는 제품 수: ${myTempCount}개 있습니다.`);
          }
        }

        // locations
        setLocationList(Array.isArray(barcodeRes?.locations) ? barcodeRes.locations : []);

        focusScanner();
      } catch (e) {
        console.error(e);
        setError(`초기화 로드 에러 : ${e?.message || "알 수 없는 오류"}`);
        setLocationList([]);
        setStateOptions([]);
      } finally {
        if (alive) setLoading(false);
      }
    })();

    return () => {
      alive = false;
    };
  }, []);

  useEffect(() => {
    const onKeyDown = (e) => {
      if (e.key === "Escape") {
        if (locModal.open) {
          e.preventDefault();
          closeLocModal();   // ✅ 수량/위치 변경 모달 닫기
        }
        if (descItem) {
          e.preventDefault();
          setDescItem(null); // ✅ 설명 팝업도 닫기(원하실 때 유지)
        }
        if (logModal.open) {
          e.preventDefault();
          closeLogModal(); 
        }
        if (specModal.open) {
          e.preventDefault();
          closeSpecModal();
        }
      }
    };
    window.addEventListener("keydown", onKeyDown, true);
    return () => window.removeEventListener("keydown", onKeyDown, true);
  }, [locModal.open, descItem, logModal.open, specModal.open]);

  // 🔹 검색 필터 (&, |, ! 연산 지원)
  useEffect(() => {
    let result = [...items];

    if (showFavoritesOnly && favoritesKey) {
      result = result.filter((item) => favorites.includes(item.id));
    }

    if (searchTerm.trim() !== "") {
      const matchItem = (item) => {
        const fields = {
          "카테고리": `${item.category_display_name || ""}`.toLowerCase(),
          "대분류": `${item.product__category__major_category__name || ""}`.toLowerCase(),
          "소분류": `${item.product__category__name || ""}`.toLowerCase(),
          "품명": `${item.product__name || ""}`.toLowerCase(),
          // "패키지": `${item.product__package__major_package__name || ""} ${item.product__package__option || ""}`.toLowerCase(),
          "패키지": `${item.product__package_display || ""}`.toLowerCase(),
          "스펙": `${item.product__display_spec || ""}`.toLowerCase(),
          "설명": `${item.product__description || ""}`.toLowerCase(),
          "위치": `${item.location_display_name || ""} ${item.temp_inventory || ""}`.toLowerCase(),
          "상태": `${item.state__name || ""}`.toLowerCase(),
          "바코드": `${item.barcode || ""} ${item.location_barcode || ""}`.toLowerCase(),
          "임시": `${item.temp_inventory ? "임시보관 임시 temp 해제": ""}`.toLowerCase(),
        };

        const allText = Object.values(fields).join(" ");

        const st = (searchTerm || "").toLowerCase().trim();
        if (!st) return true;

        // 공백은 AND, | 는 OR
        const orGroups = st
          .split("|")
          .map((g) => g.trim())
          .filter(Boolean);

        const evalAtom = (tok) => {
          // NOT
          const neg = tok.startsWith("!");
          const t = neg ? tok.slice(1) : tok;

          // 필드 지정: 키=값
          const eq = t.indexOf("=");
          if (eq > 0) {
            const key = t.slice(0, eq).trim();
            const val = t.slice(eq + 1).trim();
            const target = fields[key];
            const ok = !!target && (val ? target.includes(val) : true);
            return neg ? !ok : ok;
          }

          // 기본: 전체 검색
          const ok = allText.includes(t);
          return neg ? !ok : ok;
        };

        const evalAndGroup = (group) => {
          const tokens = tokenizeQuery(group);

          return tokens.every((tok) => {
            const neg = tok.startsWith("!");
            const raw = neg ? tok.slice(1) : tok;

            const eq = raw.indexOf("=");
            if (eq > 0) {
              const key = raw.slice(0, eq).trim();
              let val = raw.slice(eq + 1).trim();

              if (
                (val.startsWith('"') && val.endsWith('"')) ||
                (val.startsWith("'") && val.endsWith("'"))
              ) {
                val = val.slice(1, -1);
              }

              return evalAtom(`${neg ? "!" : ""}${key}=${val}`);
            }

            let val = raw;
            if (
              (val.startsWith('"') && val.endsWith('"')) ||
              (val.startsWith("'") && val.endsWith("'"))
            ) {
              val = val.slice(1, -1);
            }

            const ok = allText.includes(val);
            return neg ? !ok : ok;
          });
        };

        // OR 그룹 중 하나라도 만족하면 true
        return orGroups.some(evalAndGroup);
      };

      result = result.filter((item) => matchItem(item));
    }

    // 정렬
    const hasSearch = searchTerm.trim() !== "";

    // ✅ 실제 사용할 정렬 기준 결정
    let effectiveKey = sortConfig.key;
    let effectiveDirection = sortConfig.direction;

    if (!effectiveKey) {
      if (hasSearch) {
        // 🔹 검색어 있을 때 기본: inventory id 기준
        // effectiveKey = "id";
        effectiveKey = "category";
        effectiveDirection = "asc";
      } else {
        // 🔹 검색어 없고 정렬도 지정 안 됐을 때 기본: 대분류/소분류 기준
        effectiveKey = "category";
        effectiveDirection = "asc";
      }
    }

    if (effectiveKey) {
      result.sort((a, b) => {
        let valA, valB;

        if (effectiveKey === "favorite") {
          valA = favorites.includes(a.id) ? 1 : 0;
          valB = favorites.includes(b.id) ? 1 : 0;

        } else if (effectiveKey === "package") {
          valA =
            (a.product__package__major_package__name ?? "") +
            (a.product__package__option ?? "");
          valB =
            (b.product__package__major_package__name ?? "") +
            (b.product__package__option ?? "");
          valA = valA.toLowerCase();
          valB = valB.toLowerCase();

        } else if (effectiveKey === "category") {
          valA = `${a.category_display_name || ""}`.toLowerCase();
          valB = `${b.category_display_name || ""}`.toLowerCase();

        } else if (effectiveKey === "location") {
          valA = `${a.location_display_name || ""}`.toLowerCase()
          valB = `${b.location_display_name || ""}`.toLowerCase()
        } else {
          valA = a[effectiveKey] ?? "";
          valB = b[effectiveKey] ?? "";

          if (effectiveKey === "stock" || effectiveKey === "id") {
            valA = Number(valA);
            valB = Number(valB);
          } else {
            valA = valA.toString().toLowerCase();
            valB = valB.toString().toLowerCase();
          }
        }

        if (valA < valB) return effectiveDirection === "asc" ? -1 : 1;
        if (valA > valB) return effectiveDirection === "asc" ? 1 : -1;

        const pA = (a.product__name ?? a.product_name ?? a.name ?? "").toString().toLowerCase()
        const pB = (b.product__name ?? b.product_name ?? b.name ?? "").toString().toLowerCase()
        if (pA < pB) return -1
        if (pA > pB) return 1

        return Number(a.id) - Number(b.id)
      });
    }

    setFilteredItems(result);
  }, [searchTerm, items, favorites, showFavoritesOnly, sortConfig]);

  const showSpec = (item, e) => {
    const payload = item.product__display_spec_payload ?? null;

    if (!payload) return;

    setSpecModal({
      open: true,
      title: item.product__name || "스펙",
      spec: payload,
    });
  };

  const showDescription = (item, e) => {
    const desc = (item.product__description ?? "").trim();
    if (!desc) return;

    const r = e.currentTarget.getBoundingClientRect();
    const x = r.left + 150;
    const y = r.bottom;

    setDescPos({ x, y, strategy: "absolute" });
    setDescItem(item);
  };

  const showProductLogs = (item, e) => {
    if (e && typeof e.stopPropagation === "function") {
      e.stopPropagation();
    }

    const productId = item.product__id || item.product_id || item.id;
    const productName = item.product__name || item.product_name || "";

    if (!productId) return;

    setLogModal((s) => ({
      ...s,
      open: true,
      productId: Number(productId),
      productName,
      loading: true,
      error: null,
      logs: [],
    }));

    (async () => {
      try {
        setLoading(true);
        const j = await apiFetch(`/api/inventory/logs/${productId}/?limit=30`);
        setLogModal((s) => ({
          ...s,
          loading: false,
          logs: Array.isArray(j?.items) ? j.items : [],
          productName: j?.product?.name || s.productName,
        }));
      } catch (err) {
        alert(`이력 로드 에러 : ${e?.message || "알 수 없는 오류"}`);
        setLogModal((s) => ({
          ...s,
          loading: false,
          error: "로그를 불러오지 못했습니다.",
        }));
      } finally {
        setLoading(false);
      }
    })();
  };

  // 🔶 검색어 하이라이트 유틸
  const escapeRegExp = (s) => String(s).replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  const htmlEscape = (s) =>
    String(s ?? "").replace(/[&<>"']/g, (m) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[m]));

  const tokenizeQuery = (input) => {
    const s = String(input || "").trim();
    if (!s) return [];

    const tokens = [];
    const re = /[^\s&|]+="[^"]+"|"[^"]+"|[^&|\s]+/g;
    let m;

    while ((m = re.exec(s)) !== null) {
      const token = m[0].trim();
      if (token) tokens.push(token);
    }

    return tokens;
  };
  const highlightHTML = (text) => {
    const src = String(text ?? "");
    const q = String(searchTerm ?? "").trim();
    if (!q || !src) return htmlEscape(src);

    const rawTokens = [];
    const orGroups = q.split("|").map((g) => g.trim()).filter(Boolean);

    for (const group of orGroups) {
      const tokens = tokenizeQuery(group);
      rawTokens.push(...tokens);
    }

    const terms = [];
    for (const tok of rawTokens) {
      if (tok.startsWith("!")) continue;

      const raw = tok.startsWith("!") ? tok.slice(1) : tok;
      const eq = raw.indexOf("=");

      if (eq > 0) {
        let val = raw.slice(eq + 1).trim();
        if (
          (val.startsWith('"') && val.endsWith('"')) ||
          (val.startsWith("'") && val.endsWith("'"))
        ) {
          val = val.slice(1, -1);
        }
        if (val) terms.push(val);
      } else {
        let val = raw.trim();
        if (
          (val.startsWith('"') && val.endsWith('"')) ||
          (val.startsWith("'") && val.endsWith("'"))
        ) {
          val = val.slice(1, -1);
        }
        if (val) terms.push(val);
      }
    }

    const hlTerms = [...new Set(terms)]
      // .filter(Boolean)
      .filter((t) => t.length >= 2)
      .sort((a, b) => b.length - a.length);

    if (hlTerms.length === 0) return htmlEscape(src);

    const re = new RegExp(`(${hlTerms.map(escapeRegExp).join("|")})`, "gi");

    return src
      .split(re)
      .map((seg, i) => i % 2 ? `<mark>${htmlEscape(seg)}</mark>` : htmlEscape(seg))
      .join("");
  };

  // 즐겨찾기 저장
  const toggleFavorite = (id) => {
    if (!favoritesKey) return;
    let updated;
    if (favorites.includes(id)) {
      updated = favorites.filter((favId) => favId !== id);
    } else {
      updated = [...favorites, id];
    }
    setFavorites(updated);
    localStorage.setItem(favoritesKey, JSON.stringify(updated));
    focusScanner();
  };

  // ⭐ 별 정렬 버튼
  const handleFavoriteSort = () => {
    let direction = "asc";
    if (sortConfig.key === "favorite" && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key: "favorite", direction });
    focusScanner();
  };

  // 🔹 정렬
  const handleSort = (key) => {
    setSortConfig((prev) => {
      const direction =
        prev.key === key && prev.direction === "asc" ? "desc" : "asc";
      return { key, direction };
    });
    focusScanner();
  };

  //스마트 패트롤
  const enterSmartPatrol = (locationCode, locationItems, scannedLocation) => {
    const normalized = locationItems.map((it) => {
      const tempValue = String(it.temp_inventory || "").trim();

      let patrolStatus = "waiting";

      if (tempValue === "분실") {
        patrolStatus = "red";
      } else if (tempValue) {
        patrolStatus = "yellow";
      }

      return {
        ...it,
        patrolStatus,
        patrolChecked: false,
      };
    });

    setPatrolMode(true);
    setPatrolLocation({
      barcode: locationCode,
      id: scannedLocation?.id || null,
      name: scannedLocation?.display_name || "",
    });
    setPatrolItems(normalized);
    setPatrolScannedMap({});
    setFilteredItems(normalized);
  };

  const handleLocationScan = (cleanCode, locationMatches, scannedLocation) => {
    if (patrolMode) return false;

    if (lastLocationCode === cleanCode) {
      enterSmartPatrol(cleanCode, locationMatches, scannedLocation);
      focusScanner();
      return true;
    }

    setLastLocationCode(cleanCode);
    setFilteredItems(locationMatches);
    focusScanner();
    return true;
  };

  const handlePatrolScan = async (cleanCode) => {
    const scannedLocation = locationList.find(
      (loc) => normalize(loc.barcode) === cleanCode
    );

    if (scannedLocation) {
      const isSameLocation =
        normalize(scannedLocation.barcode) === normalize(patrolLocation?.barcode);

      if (isSameLocation) {
        focusScanner();
        return;
      }

      const nextLocationItems = items.filter(
        (it) => normalize(it.location_barcode) === cleanCode
      );

      await exitSmartPatrol({
        nextLocationCode: cleanCode,
        nextLocationItems,
        nextScannedLocation: scannedLocation,
      });
      return;
    }
    
    const scanned = items.filter((it) => normalize(it.barcode) === cleanCode);

    if (scanned.length === 0) {
      alert(`등록되지 않은 바코드: ${cleanCode}`);
      focusScanner();
      return;
    }

    const target = scanned[0];
    const patrolTarget = patrolItems.find((it) => it.id === target.id) || target;

    if (patrolTarget?.patrolStatus === "green") {
      alert("이미 처리된 제품입니다.");
      focusScanner();
      return;
    }

    const isCurrentLocation =
      normalize(patrolTarget.location_barcode) === normalize(patrolLocation?.barcode);

    const tempValue = String(patrolTarget.temp_inventory || "").trim();
    const hasTemp = !!tempValue;

    try {
      setLoading(true);

      if (isCurrentLocation) {
        if (hasTemp) {
          await apiFetch(`/api/inventory/${target.id}/hold/`, {
            method: "PATCH",
            body: { username: null },
          });
        }

        await apiFetch(`/api/inventory/${target.id}/location-check/`, {
          method: "PATCH",
          body: { username },
        });

        setItems((prev) =>
          prev.map((it) =>
            it.id === target.id
              ? { ...it, temp_inventory: null }
              : it
          )
        );

        setPatrolItems((prev) =>
          prev.map((it) =>
            it.id === target.id
              ? { ...it, temp_inventory: null, patrolStatus: "green", patrolChecked: true }
              : it
          )
        );

        focusScanner();
        return;
      }

      const ok = window.confirm(
        `${target.product__name}의 등록 위치는 ${target.location_display_name || "위치 없음"} 입니다.\n이 위치(${patrolLocation?.name || patrolLocation?.barcode || "-"})로 변경 하시겠습니까?`
      );

      if (ok) {
        const currentLocationId = patrolLocation?.id;
        if (!currentLocationId) {
          alert("현재 패트롤 위치 정보를 찾을 수 없습니다.");
          focusScanner();
          return;
        }

        await apiFetch(`/api/inventory/${target.id}/location/`, {
          method: "PATCH",
          body: { location_id: currentLocationId, username },
        });

        if (hasTemp) {
          await apiFetch(`/api/inventory/${target.id}/hold/`, {
            method: "PATCH",
            body: { username: null },
          });
        }

        const movedItem = {
          ...target,
          location_barcode: patrolLocation?.barcode || target.location_barcode,
          location_display_name: patrolLocation?.name || target.location_display_name,
          temp_inventory: null,
          patrolStatus: "green",
          patrolChecked: true,
        };

        setItems((prev) =>
          prev.map((it) =>
            it.id === target.id
              ? {
                  ...it,
                  location_barcode: patrolLocation?.barcode || it.location_barcode,
                  location_display_name: patrolLocation?.name || it.location_display_name,
                  temp_inventory: null,
                }
              : it
          )
        );

        setPatrolItems((prev) => {
          const exists = prev.some((it) => it.id === target.id);
          if (exists) {
            return prev.map((it) =>
              it.id === target.id
                ? movedItem
                : it
            );
          }
          return [...prev, movedItem];
        });

        focusScanner();
        return;
      }

      await apiFetch(`/api/inventory/${target.id}/hold/`, {
        method: "PATCH",
        body: { username },
      });

      setItems((prev) =>
        prev.map((it) =>
          it.id === target.id
            ? { ...it, temp_inventory: username }
            : it
        )
      );

      focusScanner();
    } catch (err) {
      alert(`스마트 패트롤 처리 실패 : ${err?.message || "알 수 없는 오류"}`);
    } finally {
      setLoading(false);
    }
  };

  //패트롤 대기항목 일괄 분실 처리
  const markWaitingAsMissing = async () => {
    const waitingItems = patrolItems.filter((it) => it.patrolStatus === "waiting");

    for (const item of waitingItems) {
      await apiFetch(`/api/inventory/${item.id}/hold/`, {
        method: "PATCH",
        body: { username: "분실" },
      });
    }

    setPatrolItems((prev) =>
      prev.map((it) =>
        it.patrolStatus === "waiting"
          ? { ...it, temp_inventory: "분실", patrolStatus: "red" }
          : it
      )
    );
  };

  // 이탈경고
  const handleExitClick = async () => {
    const hasPending = patrolItems.some(
      (it) => it.patrolStatus === "waiting" || it.patrolStatus === "red"
    );

    if (!hasPending) {
      skipBeforeUnloadRef.current = true;
      window.location.reload();
      return;
    }

    const ok = window.confirm(
      "변경사항이 저장되지 않을 수 있습니다.\n종료하시겠습니까?"
    );

    if (!ok) return;

    skipBeforeUnloadRef.current = true; //새로고침 경고 해제
    window.location.reload();
  };

  const exitSmartPatrol = async ({
    nextLocationCode = null,
    nextLocationItems = [],
    nextScannedLocation = null,
    forceCompleteConfirm = false,
  } = {}) => {
    const targets = patrolItems.filter(
      (it) => it.patrolStatus === "waiting" || it.patrolStatus === "red"
    );

    if (forceCompleteConfirm) {
      const ok = window.confirm("완료되었습니다. 종료하시겠습니까?");
      if (!ok) return false;
    } else if (targets.length > 0) {
      const ok = window.confirm(
        "확인되지 않은 항목이 있습니다.\n나가면 모두 분실 처리됩니다.\n계속하시겠습니까?"
      );
      if (!ok) return false;
    }

    try {
      setLoading(true);

      for (const item of targets) {
        await apiFetch(`/api/inventory/${item.id}/hold/`, {
          method: "PATCH",
          body: { username: "분실" },
        });
      }

      setItems((prev) =>
        prev.map((it) => {
          const found = targets.some((t) => t.id === it.id);
          return found
            ? { ...it, temp_inventory: "분실" }
            : it;
        })
      );

      setPatrolMode(false);
      setPatrolLocation(null);
      setPatrolItems([]);
      setPatrolScannedMap({});
      setLastLocationCode("");
      setSearchTerm("");

      if (nextLocationCode && nextScannedLocation) {
        enterSmartPatrol(nextLocationCode, nextLocationItems, nextScannedLocation);
      } else {
        setFilteredItems(items);
        focusScanner();
      }

      return true;
    } catch (err) {
      alert(`스마트 패트롤 종료 실패 : ${err?.message || "알 수 없는 오류"}`);
      return false;
    } finally {
      setLoading(false);
    }
  };

  // useEffect(() => {
  //   if (patrolMode) {
  //     setNavigationBlocker(true, exitSmartPatrol);
  //   } else {
  //     clearNavigationBlocker();
  //   }

  //   return () => {
  //     clearNavigationBlocker();
  //   };
  // }, [patrolMode, exitSmartPatrol]);

  // 수량변경 제한
  const canEditPatrolStock = (item) => {
    if (!patrolMode) return true;
    return item.patrolStatus === "green";
  };

  // 🔹 스캔 처리(버퍼 확정값으로만 비교)
  const handleScan = async (code) => {
    const cleanCode = normalize(code);

    // console.log("scan raw =", JSON.stringify(code));
    // console.log("scan clean =", JSON.stringify(cleanCode));
    // console.log("lastLocationCode =", JSON.stringify(lastLocationCode));

    if (locModal.open) {
      const scannedLocation = locationList.find(
        (loc) => normalize(loc.barcode) === cleanCode
      );

      if (!scannedLocation) {
        alert(`등록되지 않은 위치 바코드: ${cleanCode}`);
        return;
      }

      if (locModal.mode === "location") {
        setLocChangeText(scannedLocation.display_name || "");
        setLocModal((prev) => ({
          ...prev,
          locationId: String(scannedLocation.id),
        }));
        return;
      }

      if (locModal.mode === "state") {
        setSplitLocText(scannedLocation.display_name || "");
        setLocModal((prev) => ({
          ...prev,
          locationId: String(scannedLocation.id),
        }));
        return;
      }

      return;
    }

    setSearchTerm(code);

    if (patrolMode) {
      await handlePatrolScan(cleanCode);
      return;
    }

    const productMatches = items.filter(
      (it) => normalize(it.barcode) === cleanCode
    );
    // console.log("productMatches =", productMatches.length);
    
    if (productMatches.length > 0) {
      setFilteredItems(productMatches);

      const favMatches = productMatches.filter((it) => favorites.includes(it.id));

      if (favMatches.length > 1) {
        alert("임시 보관 후보가 여러개입니다");
        focusScanner();
        return;
      }

      if (favMatches.length === 1) {
        const target = favMatches[0];
        const confirmMove = window.confirm(`${target.product__name} 제품을 임시 보관으로 이동하시겠습니까?`);
        if (confirmMove) {
          try {
            setLoading(true);
            await apiFetch(`/api/inventory/${target.id}/hold/`, {
              method: "PATCH",
              body: { username },
            });

            toggleFavorite(target.id);
            setItems((prev) =>
              prev.map((it) => (it.id === target.id ? { ...it, temp_inventory: username } : it))
            );
            alert("✅ 임시 보관으로 이동되었습니다.");
          } catch (err) {
            alert(`임시 보관 실패 : ${err?.message || "알 수 없는 오류"}`);
          } finally {
            setLoading(false);
          }
        }
      }

      focusScanner();
      return;
    }

    const scannedLocation = locationList.find(
      (loc) => normalize(loc.barcode) === cleanCode
    );

    if (scannedLocation) {
      const locationMatches = items.filter(
        (it) => normalize(it.location_barcode) === cleanCode
      );

      const handled = handleLocationScan(cleanCode, locationMatches, scannedLocation);
      if (handled) return;
    }

    setFilteredItems([]);
    alert(`등록되지 않은 바코드: ${cleanCode}`);
    focusScanner();
  };

  const downloadExcel = async () => {
    const ok = window.confirm("엑셀을 다운로드하시겠습니까?");
    if (!ok) return;

    // 1) filteredItems에 있는 productId 모으기
    const productIds = Array.from(
      new Set(
        filteredItems
          .map((item) => item.product__id || item.product_id || item.id)
          .filter(Boolean)
      )
    );

    // 2) productId -> { supplier, price } 매핑
    const purchaseMap = {};

    await Promise.all(
      productIds.map(async (pid) => {
        try {
          setLoading(true);
          const list = await apiFetch(`/api/product/purchase/?product_id=${pid}`);

          if (!Array.isArray(list) || list.length === 0) {
            purchaseMap[pid] = { supplier: "", price: "" };
            return;
          }

          const last = list[list.length - 1];
          purchaseMap[pid] = {
            supplier: last.supplier_name || "",
            price: last.price ?? "",
          };
        } catch (e) {
          alert(`구매처 로드 에러 : ${e?.message || "알 수 없는 오류"}`);
          purchaseMap[pid] = { supplier: "", price: "" };
        } finally {
          setLoading(false);
        }
      })
    );

    // 3) 엑셀 데이터 생성 (여기서 Supplier, Price 채움)
    const worksheet = XLSX.utils.json_to_sheet(
      filteredItems.map((item) => {
        const pid = item.product__id || item.product_id || item.id;
        const purchase = purchaseMap[pid] || { supplier: "", price: "" };

        return {
          Major: `${item.product__category__major_category__name || ""}`,
          Sub: `${item.product__category__name || ""}`,
          Model: item.product__name || "",
          Package: `${item.product__package__major_package__name || ""}`,
          Option: `${item.product__package__option || ""}`,
          Spec: item.product__spec_key || "",
          Description: `${item.product__description || ""}`,
          Stock: item.stock,
          Zone: `${item.location__major__name || ""}`,
          Location: `${item.location__container__name || ""}`,
          Section: `${item.location__name || ""}`,
          State: `${item.state__name || ""}`,
          Supplier: purchase.supplier,
          Price: purchase.price,
        };
      })
    );

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "재고목록");

    const wbout = XLSX.write(workbook, { bookType: "xlsx", type: "array" });

    const base = (searchTerm || "").trim() || "전체";
    const safeBase = base
      .replace(/[\\/:*?"<>|]/g, "")
      .replace(/\s+/g, "_")
      .replace(/\.+$/g, "")
      .slice(0, 80);

    const d = new Date();
    const pad = (n) => String(n).padStart(2, "0");
    const ts = `${d.getFullYear()}${pad(d.getMonth() + 1)}${pad(d.getDate())}_${pad(d.getHours())}${pad(d.getMinutes())}${pad(d.getSeconds())}`;

    const filename = `${safeBase}_재고목록_${ts}.xlsx`;

    saveAs(new Blob([wbout], { type: "application/octet-stream" }), filename);

    focusScanner();
  };

  const submitChangeStockInModal = async () => {
    if (!locModal.item) return;

    const productName = locModal.item.product__name || "이름 없음";
    const prevStock = Number(locModal.item.stock ?? 0);

    try {
      setLoading(true);
      setLabelBusy(true);

      const data = await apiFetch(`/api/inventory/${locModal.item.id}/stock/`, {
        method: "PATCH",
        body: { stock: String(locModal.stock ?? ""), action: "CHECK", username },
      });

      setItems((prev) =>
        prev.map((it) => (it.id === locModal.item.id ? { ...it, stock: data.stock } : it))
      );

      const newStock = Number(data.stock);
      alert(`✅ ${productName}\n▶ 재고 ${prevStock} → ${newStock}`);

      closeLocModal();
    } catch (err) {
      alert(`수량 변경 실패 : ${err?.message || "알 수 없는 오류"}`);
    } finally {
      setLabelBusy(false);
      focusScanner();
      setLoading(false);
    }
  };

  const submitChangeLocation = async () => {
    if (!locModal.item) return;
    const locationId = Number(locModal.locationId);
    if (!locationId) {
      alert("위치를 선택하세요.");
      return;
    }

    try {
      setLoading(true);
      setLabelBusy(true);

      const data = await apiFetch(`/api/inventory/${locModal.item.id}/location/`, {
        method: "PATCH",
        body: { location_id: locationId, username },
      });

      setItems((prev) =>
        prev.map((it) =>
          it.id === locModal.item.id
            ? {
                ...it,
                location_display_name : data.new_location?.display_name || "",
                location_barcode: data.new_location?.barcode || "",
              }
            : it
        )
      );

      alert("✅ 위치가 변경되었습니다.");
      closeLocModal();
    } catch (err) {
      alert(`위치 변경 실패 : ${err?.message || "알 수 없는 오류"}`);
    } finally {
      setLabelBusy(false);
      focusScanner();
      setLoading(false);
    }
  };

  const getStateNameById = (id) => {
    const o = stateOptions.find((x) => String(x.id ?? x.value) === String(id));
    return o?.name ?? o?.label ?? "";
  };

  // ✅ 상태 변경(전량/일부 + 위치옵션)
  const submitStateChangeSmart = async () => {
    if (!locModal.item) return;

    const curStock = Number(locModal.item?.stock || 0);
    const qty = Number(locModal.transferQty);
    const toStateId = Number(locModal.stateId);
    const toLocationId = Number(locModal.locationId) || null;

    if (!toStateId) {
      alert("새 상태를 선택하세요.");
      return;
    }
    if (!qty || qty < 1 || qty > curStock) {
      alert(`변경 수량은 1 ~ ${curStock} 사이여야 합니다.`);
      return;
    }

    const targetStateName = getStateNameById(toStateId);

    try {
      setLoading(true);
      setLabelBusy(true);

      // 전량
      if (qty === curStock) {
        if (String(locModal.item.state__name || "") === targetStateName && toLocationId === null) {
          alert("변경사항 없음");
          return;
        }

        // 상태 변경
        if (String(locModal.item.state__name || "") !== targetStateName) {
          const d1 = await apiFetch(`/api/inventory/${locModal.item.id}/state/`, {
            method: "PATCH",
            body: { state_id: toStateId, username },
          });

          setItems((prev) =>
            prev.map((it) =>
              it.id === locModal.item.id
                ? { ...it, state__name: d1.new_state?.name || targetStateName }
                : it
            )
          );
        }

        // 위치 변경(선택)
        if (toLocationId) {
          const d2 = await apiFetch(`/api/inventory/${locModal.item.id}/location/`, {
            method: "PATCH",
            body: { location_id: toLocationId, username },
          });

          setItems((prev) =>
            prev.map((it) =>
              it.id === locModal.item.id
                ? {
                    ...it,
                    location_display_name : d2.new_location?.display_name || "",
                    location_barcode: d2.new_location?.barcode || "",
                  }
                : it
            )
          );
        }

        alert("✅ 상태/위치 변경 완료(전량).");
        closeLocModal();
        return;
      }

      // 일부 분리
      const data = await apiFetch("/api/inventory/update-split/", {
        method: "POST",
        body: {
          inventory_id: locModal.item.id,
          quantity: qty,
          state_id: toStateId,
          location_id: toLocationId || null,
          username,
        },
      });

      const src = data.source;
      const dst = data.destination;

      setItems((prev) => {
        const existsDest = prev.some((it) => it.id === dst.inventory_id);

        const updated = prev.map((it) => {
          if (it.id === src.inventory_id) {
            return { ...it, stock: src.stock };
          }
          if (it.id === dst.inventory_id) {
            return {
              ...it,
              stock: dst.stock,
              state__name: dst.state?.name || it.state__name || "",
              location_display_name: dst.location?.display_name ?? it.location_display_name_name ?? "",
              location_barcode: dst.location?.barcode ?? it.location_barcode ?? "",
            };
          }
          return it;
        });

        if (!existsDest) {
          updated.push({
            ...locModal.item,
            id: dst.inventory_id,
            stock: dst.stock,
            state__name: dst.state?.name || "",
            location_display_name: dst.location?.display_name || "",
            location_barcode: dst.location?.barcode || "",
          });
        }

        return updated;
      });

      alert("✅ 상태/수량 이동 완료(일부).");
      closeLocModal();
    } catch (e) {
      alert("❌ " + (e?.message || "상태 변경 실패"));
    } finally {
      setLabelBusy(false);
      focusScanner();
      setLoading(false);
    }
  };

  const updateDescPos = (e) => {
    const r = e.currentTarget.getBoundingClientRect();
    setDescPos({ x: r.left + 150, y: r.bottom, strategy: "absolute" });
  };

  const handleRemoveTemp = async (inventoryId) => {
    if (!window.confirm("임시보관 리스트에서 제거하시겠습니까?")) return;

    try {
      setLoading(true);
      await apiFetch(`/api/inventory/${inventoryId}/hold/`, {
        method: "PATCH",
        body: { username: null },
      });

      setItems((prev) =>
        prev.map((it) => (it.id === inventoryId ? { ...it, temp_inventory: null } : it))
      );

      alert("임시보관 리스트에서 제거되었습니다.");
    } catch (error) {
      alert(`임시보관 해제 실패 : ${error?.message || "알 수 없는 오류"}`);
    } finally {
      focusScanner();
      setLoading(false);
    }
  };

  const closeLocModal = () => setLocModal({ open: false, item: null, locationId: "", stock: "", stateId: "", transferQty: "", mode: "location" });
  const closeLogModal = () => setLogModal({ open: false, productId: null, productName: "", logs: [], loading: false, error: null, });
  const closeSpecModal = () => setSpecModal({ open: false, title: "", spec: null });

  // if (loading) return <p>재고 데이터를 불러오는 중...</p>;

  const getSortedItems = (list) => {
    const result = [...list];

    let effectiveKey = sortConfig.key;
    let effectiveDirection = sortConfig.direction;

    if (!effectiveKey) {
      effectiveKey = "category";
      effectiveDirection = "asc";
    }

    result.sort((a, b) => {
      let valA, valB;

      if (effectiveKey === "favorite") {
        valA = favorites.includes(a.id) ? 1 : 0;
        valB = favorites.includes(b.id) ? 1 : 0;
      } else if (effectiveKey === "package") {
        valA =
          (a.product__package__major_package__name ?? "") +
          (a.product__package__option ?? "");
        valB =
          (b.product__package__major_package__name ?? "") +
          (b.product__package__option ?? "");
        valA = valA.toLowerCase();
        valB = valB.toLowerCase();
      } else if (effectiveKey === "category") {
        valA = `${a.category_display_name || ""}`.toLowerCase();
        valB = `${b.category_display_name || ""}`.toLowerCase();
      } else if (effectiveKey === "location") {
        valA = `${a.location_display_name || ""}`.toLowerCase();
        valB = `${b.location_display_name || ""}`.toLowerCase();
      } else {
        valA = a[effectiveKey] ?? "";
        valB = b[effectiveKey] ?? "";

        if (effectiveKey === "stock" || effectiveKey === "id") {
          valA = Number(valA);
          valB = Number(valB);
        } else {
          valA = String(valA).toLowerCase();
          valB = String(valB).toLowerCase();
        }
      }

      if (valA < valB) return effectiveDirection === "asc" ? -1 : 1;
      if (valA > valB) return effectiveDirection === "asc" ? 1 : -1;

      return Number(a.id) - Number(b.id);
    });

    return result;
  };

  const patrolDisplayItems = patrolMode
    ? getSortedItems(patrolItems)
    : filteredItems;

  if (error) return <p>에러 발생: {error}</p>;

  return (
    <div className={`inventory-page ${patrolMode ? "patrol-theme" : ""}`}>
      <Loading active={loading} />
      <div className="inventory-header">
        <div className={`title-row ${patrolMode ? "patrol-title-row" : ""}`}>
          <h1 className="inventory-title">
            {patrolMode ? "📦 스마트 패트롤" : "📦 재고 관리"}
          </h1>
          <Scanner ref={scannerRef} onScan={(value) => handleScan(value)} />

          {patrolMode && (
            <div className="patrol-header-actions">
              {isMobile && (
                <button
                  className="trans-btn icon-text-btn"
                  onClick={() => setShowScanner(true)}
                >
                  <span className="btn-icon">📷</span>
                  <span className="btn-text">카메라</span>
                </button>
              )}

              <button
                className="trans-btn icon-text-btn danger-btn"
                // onClick={() => { exitSmartPatrol(); }}
                onClick={handleExitClick}
              >
                <span className="btn-icon">🚪</span>
                <span className="btn-text">나가기</span>
              </button>
            </div>
          )}
        </div>

        {!patrolMode && (
          <div className="search-container">
            <input
              type="text"
              ref={searchInputRef}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              onKeyDown={async (e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                  await handleScan(searchTerm);
                }
              }}
              placeholder='검색: 품명, 스펙, 카테고리, 패키지, 위치 (&, |, !, "" 가능)'
              className="search-input"
            />
            <button onClick={downloadExcel} className="trans-btn icon-text-btn">
              <span className="btn-icon">💾</span>
              <span className="btn-text">엑셀 다운</span>
            </button>

            {isMobile && (
              <button
                className="trans-btn icon-text-btn"
                onClick={() => setShowScanner(true)}
              >
                <span className="btn-icon">📷</span>
                <span className="btn-text">카메라</span>
              </button>
            )}
          </div>
        )}

        {showScanner && (
          <CamScanner
            onDetected={handleDetected}
            onClose={() => setShowScanner(false)}
          />
        )}
      </div>

      <div className="inventory-table-wrap">
        <table className="inventory-table">
          <thead>
            <tr>
              <th>
                {patrolMode ? (
                  "위치상태"
                ) : (
                  <>
                    <span
                      className={`favorite-star ${showFavoritesOnly ? "on" : ""}`}
                      onClick={() => {
                        setShowFavoritesOnly(!showFavoritesOnly);
                        focusScanner();
                      }}
                    >
                      {/* {showFavoritesOnly ? "⭐" : "☆"} */}
                      ⭐
                    </span>

                    <button className="sort-btn" onClick={handleFavoriteSort}>
                      ⇅
                    </button>
                  </>
                )}
              </th>
              <th>
                카테고리{" "}
                <button className="sort-btn" onClick={() => handleSort("category")}>⇅</button>
              </th>
              <th>
                품명 <button className="sort-btn" onClick={() => handleSort("product__name")}>⇅</button>
              </th>
              <th>
                패키지 <button className="sort-btn" onClick={() => handleSort("package")}>⇅</button>
              </th>
              <th>
                스펙 <button className="sort-btn" onClick={() => handleSort("product__display_spec")}>⇅</button>
              </th>
              <th>
                재고 <button className="sort-btn" onClick={() => handleSort("stock")}>⇅</button>
              </th>
              <th>
                위치 <button className="sort-btn" onClick={() => handleSort("location")}>⇅</button>
              </th>
              <th>
                상태 <button className="sort-btn" onClick={() => handleSort("state__name")}>⇅</button>
              </th>
            </tr>
          </thead>
          <tbody>
            {patrolDisplayItems.length > 0 ? (
              patrolDisplayItems.map((item) => (
                <tr
                  key={item.id}
                  className={`data-row ${
                    patrolMode
                      ? `patrol-row patrol-${item.patrolStatus || "waiting"}`
                      : String(item.temp_inventory || "").trim() === "분실"
                      ? "missing-row"
                      : ""
                  }`}
                >
                  <td
                    style={{
                      cursor: patrolMode ? "default" : "pointer",
                      textAlign: "center",
                    }}
                    onClick={() => {
                      if (patrolMode) return;
                      toggleFavorite(item.id);
                    }}
                  >
                    {patrolMode ? (
                      item.patrolStatus === "green"
                        ? "정상"
                        : item.patrolStatus === "red"
                        ? "분실"
                        : item.patrolStatus === "yellow"
                        ? "외부"
                        : "대기"
                    ) : (
                      favorites.includes(item.id) ? "⭐" : "☆"
                    )}
                  </td>
                  <td
                    className="cell"
                    dangerouslySetInnerHTML={{
                      __html: highlightHTML(
                        // `${item.product__category__major_category__name || "대분류 없음"} / ${item.product__category__name || "소분류 없음"}`
                        `${item.category_display_name || "카테고리 없음"}`
                      ),
                    }}
                  />
                  <td
                    className="cell"
                    onMouseEnter={(e) => showDescription(item, e)}
                    onMouseMove={(e) => updateDescPos(e)}
                    onMouseLeave={() => setDescItem(null)}
                    style={{ cursor: item?.product__description ? "help" : "default" }}
                    onDoubleClick={(e) => showProductLogs(item, e)}
                    onClick={(e) => {
                      if (isMobile) showProductLogs(item, e);
                    }}
                  >
                    <span dangerouslySetInnerHTML={{ __html: highlightHTML(item.product__name || "") }} />
                  </td>
                  <td
                    className="cell"
                    dangerouslySetInnerHTML={{
                      __html: highlightHTML(
                        // JSON.stringify(item.product__spec ?? {})
                        `${item.product__package__major_package__name || ""}${
                          item.product__package__option ? `-${item.product__package__option}` : ""
                        }`
                      ),
                    }}
                  />
                  <td
                    className={`cell spec-cell ${searchTerm.trim() ? "expanded" : ""}`}
                    // onClick={(e) => {
                    //   if (isMobile) showDescription(item, e);
                    // }}
                    onDoubleClick={(e) => showSpec(item, e)}
                    onClick={(e) => {
                      if (isMobile) showSpec(item, e);
                    }}
                  >
                    <span
                      className="ellipsis-text"
                      dangerouslySetInnerHTML={{
                        __html: highlightHTML(
                          item.product__display_spec !== null && item.product__display_spec !== undefined
                            ? String(item.product__display_spec)
                            : ""
                        ),
                      }}
                    />
                  </td>
                  <td className="cell" 
                    onDoubleClick={() => {
                      if (!canEditPatrolStock(item)) {
                        alert("확인 완료된 제품만 수량 변경할 수 있습니다.");
                        return;
                      }
                      changeMetadata(item, "stock");
                    }}
                    onClick={() => {
                      if (isMobile) {
                        if (!canEditPatrolStock(item)) {
                          alert("확인 완료된 제품만 수량 변경할 수 있습니다.");
                          return;
                        }
                        changeMetadata(item, "stock");
                      }
                    }}
                    style={{ cursor: "pointer" }}
                  >
                    <div className="stock-display">
                      <span>{item.stock}</span>
                    </div>
                  </td>
                  <td className="cell" 
                    onDoubleClick={() => {
                      if (patrolMode) return;
                      changeMetadata(item, "location");
                    }}
                    onClick={() => {
                      if (isMobile) {
                        if (patrolMode) return;
                        changeMetadata(item, "location");
                      }
                    }}
                    style={{ cursor: patrolMode ? "default" : "pointer" }}
                  >
                    {item.temp_inventory ? (
                      <>
                        <span
                          dangerouslySetInnerHTML={{
                            __html: highlightHTML(
                              `${item.temp_inventory} / ${item.location_display_name}`
                            ),
                          }}
                        />
                        {String(item.temp_inventory).trim() !== "분실" && (
                          <button
                            className="delete-btn"
                            onClick={(e) => {
                              e.stopPropagation();
                              e.preventDefault();
                              handleRemoveTemp(item.id);
                            }}
                          >
                            해제
                          </button>
                        )}
                      </>
                    ) : (
                      <span
                        dangerouslySetInnerHTML={{
                          __html: highlightHTML(
                            `${item.location_display_name}`
                          ),
                        }}
                      />
                    )}
                  </td>
                  <td
                    className="cell"
                    onDoubleClick={() => {
                      if (patrolMode) return;
                      changeMetadata(item, "state");
                    }}
                    onClick={() => {
                      if (isMobile) {
                        if (patrolMode) return;
                        changeMetadata(item, "state");
                      }
                    }}
                    style={{ cursor: patrolMode ? "default" : "pointer" }}
                  >
                    <span
                      className="state-badge"
                      data-state={(item.state__name || "상태 없음").toLowerCase()}
                    >
                      <span
                        dangerouslySetInnerHTML={{
                          __html: highlightHTML(item.state__name || "상태 없음"),
                        }}
                      />
                    </span>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="8" style={{ textAlign: "center", fontWeight: "bold", color: "black" }}>
                  재고 없음
                </td>
              </tr>
            )}
            <tr>
              <td colSpan="8" style={{ textAlign: "right", fontWeight: "bold", color: "black" }}>
                총 제품 종류: {patrolDisplayItems.length}개
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      {descItem && !isMobile && (
        <div
          className="desc-popup"
          style={{ "--dx": `${descPos.x}px`, "--dy": `${descPos.y}px` }}
        >
          <div style={{ display: "flex", alignItems: "center", marginBottom: 6 }}>
            <strong style={{ fontSize: 14, flex: 1 }}>{descItem.product__name || "품명 없음"}</strong>
            <button
              onClick={() => setDescItem(null)}
              style={{ border: "none", background: "transparent", fontSize: 18, cursor: "pointer" }}
              aria-label="닫기"
              title="닫기"
            >
              ×
            </button>
          </div>

          <div style={{ fontSize: 13, lineHeight: 1.5, whiteSpace: "pre-wrap" }}>
            <b>설명:</b> {descItem.product__description}
          </div>
        </div>
      )}
      {locModal.open && (
        <div className="modal-backdrop">
          <div className="modal-card" role="dialog" aria-modal="true">
            <div className="modal-header">
              <strong>
                {locModal.mode === "location"
                  ? "위치 변경"
                  : locModal.mode === "stock"
                  ? "수량 변경"
                  : "상태 변경 & 재고 이동"}
              </strong>
              <button className="modal-close" onClick={closeLocModal}>×</button>
            </div>

            <div className="modal-body">
              {locModal.mode === "location" && (
                <>
                  <div className="modal-row">
                    <div className="modal-label">제품</div>
                    <div className="modal-value">
                      {locModal.item?.product__name} ({locModal.item?.product__display_spec || "-"})
                    </div>
                  </div>

                  <div className="modal-row">
                    <div className="modal-label">현재 위치</div>
                    <div className="modal-value">
                      {(() => {
                        const it = locModal.item || {};
                        return `${it.location_display_name}`
                      })()}
                    </div>
                  </div>

                  <div className="modal-row">
                    <div className="modal-label">새 위치</div>
                    <div className="modal-value cam">
                      <AutocompleteSelect
                        value={locModal.locationId ?? ""}
                        text={locChangeText}
                        setText={setLocChangeText}
                        options={locationList}
                        getLabel={(loc) =>
                          loc.display_name ||
                          (loc.container_name
                            ? `${loc.container_name}${loc.name ? `-${loc.name}` : ""}`
                            : (loc.name || "(이름없음)"))
                        }
                        placeholder="위치 검색 (예: A-01)"
                        onSelect={(loc) => {
                          setLocModal((s) => ({ ...s, locationId: String(loc.id) }));
                        }}
                      />
                      {isMobile && (
                        <button className="trans-btn modal"
                          onClick={() => openScanner("location")}
                          type="button"
                        >
                          📷
                        </button>
                      )}
                    </div>
                  </div>
                </>
              )}

              {locModal.mode === "stock" && (
                <>
                  <div className="modal-row">
                    <div className="modal-label">제품</div>
                    <div className="modal-value">
                      {locModal.item?.product__name} ({locModal.item?.product__display_spec || "-"})
                    </div>
                  </div>

                  <div className="modal-row">
                    <div className="modal-label">현재 수량</div>
                    <div className="modal-value">{locModal.item?.stock ?? 0}</div>
                  </div>

                  <div className="modal-row">
                    <div className="modal-label">새 수량</div>
                    <div className="modal-value">
                      <input
                        type="number"
                        className="modal-input"
                        value={locModal.stock}
                        onChange={(e) => setLocModal((s) => ({ ...s, stock: e.target.value }))}
                        placeholder="변경할 수량 입력"
                      />
                    </div>
                  </div>
                </>
              )}

              {locModal.mode === "state" && (
                <>
                  <div className="modal-row">
                    <div className="modal-label">제품</div>
                    <div className="modal-value">
                      {locModal.item?.product__name} ({locModal.item?.product__display_spec || "-"})
                    </div>
                  </div>

                  {/* ✅ 추가: 변경 수량 */}
                  <div className="modal-row">
                    <div className="modal-label">분리 수량</div>
                    <div className="modal-value">
                      <input
                        type="number"
                        className="modal-input"
                        value={locModal.transferQty ?? ""}
                        onChange={(e) => {
                          const max = Number(locModal.item?.stock || 0);
                          const min = 1;
                          let v = e.target.value;

                          // 비워두는 건 허용
                          if (v === "") {
                            setLocModal((s) => ({ ...s, transferQty: "" }));
                            return;
                          }

                          let n = Number(v);

                          if (Number.isNaN(n)) {
                            return;
                          }

                          if (n < min) n = min;
                          if (n > max) n = max;

                          setLocModal((s) => ({ ...s, transferQty: String(n) }));
                        }}
                        min={1}
                        max={Number(locModal.item?.stock || 0)}
                        placeholder={`1 ~ ${Number(locModal.item?.stock || 0)}`}
                      />
                    </div>
                  </div>

                  {/* ✅ 추가: 새 위치(선택) */}
                  <div className="modal-row">
                    <div className="modal-label">분리 위치(선택)</div>
                    <div className="modal-value cam">
                      <AutocompleteSelect
                        value={locModal.locationId ?? ""}
                        text={splitLocText}
                        setText={setSplitLocText}
                        options={locationList}
                        getLabel={(loc) =>
                          loc.display_name ||
                          (loc.container_name
                            ? `${loc.container_name}${loc.name ? `-${loc.name}` : ""}`
                            : (loc.name || "(이름없음)"))
                        }
                        placeholder="변경 안 함"
                        onSelect={(loc) => {
                          setLocModal((s) => ({ ...s, locationId: String(loc.id) }));
                        }}
                      />
                      {isMobile && (
                        <button className="trans-btn modal"
                          onClick={() => openScanner("splitLocation")}
                          type="button"
                        >
                          📷
                        </button>
                      )}
                    </div>
                  </div>

                  <div className="modal-row">
                    <div className="modal-label">분리 상태</div>
                    <div className="modal-value">
                      <select
                        className="modal-input"
                        value={locModal.stateId ?? ""}
                        onChange={(e) => setLocModal((s) => ({ ...s, stateId: e.target.value }))}
                      >
                        <option value="">상태를 선택하세요</option>
                        {stateOptions.map((opt) => (
                          <option key={String(opt.id ?? opt.value)} value={String(opt.id ?? opt.value)}>
                            {opt.name ?? opt.label ?? String(opt.id ?? opt.value)}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </>
              )}
            </div>

            <div className="modal-footer">
              {locModal.mode === "location" && (
                <button
                  className="blue-btn"
                  onClick={submitChangeLocation}
                  disabled={labelBusy || !Number(locModal.locationId)}
                >
                  {labelBusy ? "작업 중..." : "위치 변경"}
                </button>
              )}

              {locModal.mode === "stock" && (
                <button
                  className="blue-btn"
                  onClick={submitChangeStockInModal}
                  disabled={labelBusy}
                  // disabled={String(locModal.stock ?? "") === String(locModal.item?.stock ?? "")}
                >
                  {labelBusy ? "작업 중..." : "수량 변경"}
                </button>
              )}

              {locModal.mode === "state" && (
                <button
                  className="blue-btn"
                  onClick={submitStateChangeSmart}
                  disabled={
                    labelBusy ||
                    !locModal.stateId ||
                    !locModal.transferQty ||
                    Number(locModal.transferQty) < 1 ||
                    Number(locModal.transferQty) > Number(locModal.item?.stock || 0)
                  }
                >
                  {labelBusy ? "작업 중..." : "상태 변경"}
                </button>
              )}
            </div>
          </div>
        </div>
      )}

      {logModal.open && (
        <div className="modal-backdrop">
          <div className="modal-card" role="dialog" aria-modal="true">
            <div className="modal-header">
              <strong>
                재고 이력 - {logModal.productName || `#${logModal.productId}`}
              </strong>
              <button className="modal-close" onClick={closeLogModal}>×</button>
            </div>

            <div className="modal-body">
              {logModal.loading && (
                <div className="modal-row">
                  <div className="modal-value">불러오는 중...</div>
                </div>
              )}

              {logModal.error && (
                <div className="modal-row">
                  <div className="modal-value" style={{ color: "#fca5a5" }}>
                    {logModal.error}
                  </div>
                </div>
              )}

              {!logModal.loading && !logModal.error && logModal.logs.length === 0 && (
                <div className="modal-row">
                  <div className="modal-value">이력이 없습니다.</div>
                </div>
              )}

              {!logModal.loading && !logModal.error && logModal.logs.length > 0 && (
                <table className="modal-table">
                  <thead>
                    <tr>
                      <th>시간</th>
                      <th>유형</th>
                      <th>변경</th>
                      <th>재고</th>
                      <th>상태</th>
                      <th>위치</th>
                      <th>계정</th>
                    </tr>
                  </thead>
                  <tbody>
                    {logModal.logs.map((log) => (
                      <tr key={log.id}>
                        <td>{new Date(log.timestamp).toLocaleString()}</td>
                        <td>{log.action_display}</td>
                        <td>{log.quantity_change}</td>
                        <td>{log.final_stock}</td>
                        <td>{log.state_name || "-"}</td>
                        <td>{log.location_name || "-"}</td>
                        <td>{log.account_username || "-"}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>

            {!patrolMode && (
              <div className="modal-footer">
                <a
                  className="blue-btn"
                  href={`/logs/${logModal.productId}`}
                >
                  전체 로그
                </a>
              </div>
            )}
          </div>
        </div>
      )}

      {specModal.open && (
        <div className="modal-backdrop">
          <div className="modal-card" role="dialog" aria-modal="true" style={{ maxWidth: 720 }}>
            <div className="modal-header">
              <strong>스펙 - {specModal.title}</strong>
              <button className="modal-close" onClick={closeSpecModal}>×</button>
            </div>

            <div className="modal-body">
              {(() => {
                const rows = flattenSpecRows(specModal.spec);
                const payload = toSpecObj(specModal.spec);

                const group = payload && typeof payload === "object" ? (payload.group ?? "") : "";
                const display = payload && typeof payload === "object" ? (payload.display ?? "") : "";

                return (
                  <>
                    {(group || display) && (
                      // <div className="modal-row">
                      //   <div className="modal-label">요약</div>
                        <div className="modal-value">
                          {group ? <b style={{ marginRight: 8 }}>[{String(group)}]</b> : null}
                          {String(display || "")}
                        </div>
                      // </div>
                    )}

                    {rows.length === 0 ? (
                      <div className="modal-row">
                        <div className="modal-value">스펙 데이터가 없습니다.</div>
                      </div>
                    ) : (
                      <table className="modal-table">
                        <thead>
                          <tr>
                            <th>스펙명</th>
                            <th>스펙</th>
                            {/* <th>원값</th> */}
                          </tr>
                        </thead>
                        <tbody>
                          {rows.map((r, idx) => (
                            <tr key={`${r.key}_${idx}`}>
                              <td><b>{r.key}</b></td>
                              <td style={{ whiteSpace: "pre-wrap" }}>{String(r.text ?? "")}</td>
                              {/* <td style={{ whiteSpace: "pre-wrap" }}>
                                {typeof r.raw === "string" ? r.raw : JSON.stringify(r.raw)}
                              </td> */}
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    )}

                    {/* <div style={{ marginTop: 10, fontSize: 12, opacity: 0.8, whiteSpace: "pre-wrap" }}>
                      {JSON.stringify(toSpecObj(specModal.spec), null, 2)}
                    </div> */}
                  </>
                );
              })()}
            </div>

            {/* <div className="modal-footer">
              <button className="blue-btn" onClick={closeSpecModal}>닫기</button>
            </div> */}
          </div>
        </div>
      )}
    </div>
  );
}

export default Inventory;
